module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"overview":"Overview","topology":"Topology","tokens":"Tokens","geomap":"GeoMap","integrations":"Integrations","start":"Start Here","deploy":"Deploy","logout":"Logout"}}')
  delete Component.options._Ctor
}
